import './sponsors.less'

import {Carousel, useCarousel} from '@codeurs/carousel'
import {Image} from '@codeurs/front'
import React, {Fragment, useState} from 'react'
import {ImageType, LinkType} from 'types'
import {Link} from 'util/link'
import {style} from 'util/style'
import {useInterval} from 'util/useinterval'
import {Carouselnav} from 'views/layout/carousel/carouselnav'
import {Theme} from 'views/theme'

const styles = style('sponsors', ['items'])

export type SponsorsType = {
	title?: string
	subtitle?: string
	items?: Array<SponsorsItemType>
	link?: LinkType
}

export type SponsorsItemType = {
	url?: string
	logo?: ImageType
}

export const Sponsors: React.FC<SponsorsType> = ({
	title,
	subtitle,
	items,
	link
}) => {
	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					{title && <Theme.H2 className={styles('title')}>{title}</Theme.H2>}
					{subtitle && (
						<Theme.H3 className={styles('subtitle')} mod="light">
							{subtitle}
						</Theme.H3>
					)}
					<SponsorsItems items={items} />
					{link && link.url && (
						<div className={styles('link')}>
							<Theme.Link to={link.url} mod="arrowlong">
								<Theme.LinkText>
									{link.description || link.title}
								</Theme.LinkText>
								<Theme.LinkIcon icon="arrow-long" />
							</Theme.Link>
						</div>
					)}
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}

export const SponsorsItems: React.FC<{items?: Array<SponsorsItemType>}> = ({
	items
}) => {
	const carousel = useCarousel()
	const [isTouched, setIsTouched] = useState(false)
	if (!items || items.length === 0) return null

	useInterval(() => {
		if (isTouched) return
		if (carousel.hasNext()) carousel.goNext()
		else carousel.goTo(0)
	}, 5000)

	return (
		<Fragment>
			<div
				className={styles.items().mod({center: carousel.total < 2})}
				onTouchStart={() => setIsTouched(true)}
				onMouseDown={() => setIsTouched(true)}
			>
				<Carousel {...carousel}>
					{items.map((item, i) => (
						<div
							key={i}
							className={styles
								.items('item')
								.is({active: carousel.isActive(i)})}
						>
							<Link to={item.url} className={styles.items('item-block')}>
								<Image {...item.logo} />
							</Link>
						</div>
					))}
				</Carousel>
			</div>
			<Carouselnav carousel={carousel} className={styles.items('nav')} />
		</Fragment>
	)
}
